import axios from 'axios';
import { config } from '../environment';

// keys for actiontypes
export const ActionTypes = {
  UPDATE_SURVEY: 'UPDATE_SURVEY',
  UPDATE_USER: 'UPDATE_USER',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_ERROR: 'AUTH_ERROR',
  CLEAR_USER_STATUSES: 'CLEAR_USER_STATUSES',
  DEAUTH_USER: 'DEAUTH_USER',
  COMPLETED_SURVEY: 'COMPLETED_SURVEY',
  SHOW_SURVEY_ERRORS: 'SHOW_SURVEY_ERRORS',
  UPDATE_FEED: 'UPDATE_FEED',
  CLEAR_FEED: 'CLEAR_FEED',
  CLEAR_SURVEY: 'CLEAR_SURVEY',
  CLEAR_MATCHES: 'CLEAR_MATCHES',
  CLEAR_EMAIL_SENT: 'CLEAR_EMAIL_SENT',
  RESEND_SUCCESS: 'RESEND_SUCCESS',
  UPDATE_MATCHES: 'UPDATE_MATCHES',
  SWITCH_USER_TYPE: 'SWITCH_USER_TYPE',
  TOGGLE_LOAD: 'TOGGLE_LOAD',
  REVISIT_SURVEY: 'REVISIT_SURVEY',
  UPDATE_FEED_PROFILE_PHOTO: 'UPDATE_FEED_PROFILE_PHOTO',
  UPDATE_PROFILE_PHOTO: 'UPDATE_PROFILE_PHOTO',
};

export function toggleLoad() {
  return {
    type: ActionTypes.TOGGLE_LOAD,
  };
}

export function toggleProfile(isOpen) {
  return {
    type: ActionTypes.UPDATE_USER,
    payload: { profileOpen: isOpen },
  };
}

export function stopLoading() {
  return {
    type: ActionTypes.UPDATE_USER,
    payload: { loadingUserData: false },
  };
}

export function getFirstQuestion() {
  return (dispatch) => {
    return axios.get(`${config.url}/api/question/on_off_campus`, {
      headers: { authorization: localStorage.getItem('token') },
    })
      .then((response) => {
        if (response.status === 200 && response.data?.questions) {
          dispatch({
            type: ActionTypes.UPDATE_USER,
            payload: { answers: response.data.questions },
          });
        } else {
          throw new Error('Error getting survey questions');
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
}

export function getUsers(filterObj = {}) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_FEED,
      payload: { feedLoading: true },
    });
    const params = Object.entries(filterObj).map(([k, vSet]) => {
      return [...vSet].map((v) => {
        return (`${k.toLowerCase().replace(/ /g, '_')}=${v.toLowerCase()}`);
      }).join('&');
    }).join('&');
    return axios
      .get(`${config.url}/api/users?${params}`, {
        headers: { authorization: localStorage.getItem('token') },
      })
      .then((response) => {
        if (response?.data.users) {
          const formattedUsers = response.data.users.reduce((currObj, user) => {
            const { email, name, answers } = user;
            return {
              ...currObj,
              [email]: { name, answers },
            };
          }, {});
          dispatch({
            type: ActionTypes.UPDATE_FEED,
            payload: { users: formattedUsers },
          });
        } else throw new Error('Error fetching users from the server');
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.UPDATE_FEED,
          payload: { feedLoading: false },
        });
      });
  };
}

export function updateFilter(field, value, oldFilter) {
  let updatedFilter = oldFilter;
  if (field === 'search' || !(field in updatedFilter)) {
    updatedFilter = { ...updatedFilter, [field]: new Set([value]) };
  } else if (updatedFilter[field].size === 1 && updatedFilter[field].has(value)) delete updatedFilter[field];
  else if (updatedFilter[field].has(value)) updatedFilter[field].delete(value);
  else updatedFilter[field].add(value);
  updatedFilter = { ...updatedFilter };

  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ActionTypes.UPDATE_FEED,
        payload: { filter: updatedFilter },
      });
      resolve(getState().feed.filter);
    });
  };
}

export function optionSelected(currentAnswers, questionName, questionType, optionValue) {
  const currQuestionData = currentAnswers[questionName];
  let answer;
  if (questionType === 'checkbox') {
    if (!('answer' in currentAnswers[questionName])) {
      answer = [optionValue];
    } else {
      ({ answer } = currQuestionData);
      if (answer.includes(optionValue)) {
        answer.splice(answer.indexOf(optionValue), 1);
      } else {
        answer.push(optionValue);
      }
    }
  } else {
    answer = optionValue;
  }
  return {
    type: ActionTypes.UPDATE_USER,
    payload: {
      answers: { ...currentAnswers, [questionName]: { ...currQuestionData, answer } },
    },
  };
}

export function setUserType(userTypeId) {
  return (dispatch) => {
    return axios.put(`${config.url}/api/user`, { userTypeId }, {
      headers: { authorization: localStorage.getItem('token') },
    })
      .then((response) => {
        if (response.data?.success) {
          dispatch({
            type: ActionTypes.UPDATE_USER,
            payload: {
              userType: userTypeId,
            },
          });
        } else throw new Error('Error setting user type');
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
}

export function submitSurveyResponses(answers) {
  return (dispatch) => {
    const formattedAnswers = Object.keys(answers).reduce((prevValue, name) => {
      const { answer } = answers[name];
      if (name === 'profile_photo' && answer.startsWith('https://')) return prevValue;
      return { ...prevValue, [name]: (answer === null || answer === '' || answer?.length === 0) ? null : answer };
    }, {});
    return axios.put(`${config.url}/api/answers`, { answers: formattedAnswers }, {
      headers: { authorization: localStorage.getItem('token') },
    })
      .then((response) => {
        if (!response.data?.success) throw new Error('Error uploading survey answers');
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
}


export function getAnswers() {
  return (dispatch) => {
    return axios.get(`${config.url}/api/answers`, {
      headers: { authorization: localStorage.getItem('token') },
    })
      .then((response) => {
        if (response.data?.answers) {
          dispatch({
            type: ActionTypes.UPDATE_USER,
            payload: {
              answers: response.data.answers,
            },
          });
        } else throw new Error('Error getting survey answers');
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
}

export function finishSurvey() {
  return {
    type: ActionTypes.UPDATE_SURVEY,
    payload: {
      done: true,
      displayErrors: false,
    },
  };
}

export function showErrors() {
  return ({
    type: ActionTypes.SHOW_SURVEY_ERRORS,
  });
}

export function registerUser(email, password, firstname, lastname, resendEmail = false) {
  return (dispatch) => {
    return axios.post(`${config.url}/api/user`, {
      email,
      password,
      firstname,
      lastname,
    })
      .then((response) => {
        if (response.data.success) {
          dispatch({ type: resendEmail ? ActionTypes.RESEND_SUCCESS : ActionTypes.AUTH_SUCCESS });
        } else {
          dispatch({ type: ActionTypes.AUTH_ERROR });
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({ type: ActionTypes.AUTH_ERROR });
      });
  };
}

export function clearUserStatuses() {
  return {
    type: ActionTypes.CLEAR_USER_STATUSES,
  };
}

export function clearEmailSent() {
  return {
    type: ActionTypes.CLEAR_EMAIL_SENT,
  };
}

export function verifyUser(token) {
  return (dispatch) => {
    if (!token) {
      dispatch({ type: ActionTypes.AUTH_ERROR });
      return Promise.resolve();
    }
    return axios.put(`${config.url}/api/verifyuser`, null, {
      headers: { authorization: token },
    })
      .then((response) => {
        if (response.data.success) {
          dispatch({ type: ActionTypes.AUTH_SUCCESS });
        } else {
          dispatch({ type: ActionTypes.AUTH_ERROR });
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: ActionTypes.AUTH_ERROR,
        });
      });
  };
}

export function loginUser(email, password) {
  return (dispatch) => {
    return axios
      .post(`${config.url}/api/login`, {
        password,
        email,
      })
      .then((response) => {
        if (response?.data.token) {
          localStorage.setItem('token', response.data.token);
        } else throw new Error('Error fetching jwt token');
      })
      .catch((error) => {
        console.log(error);
        localStorage.clear();
        dispatch({
          type: ActionTypes.AUTH_ERROR,
        });
      });
  };
}

export function isSurveyComplete(answers) {
  return Object.values(answers).every(({ answer, required }) => {
    return !required || (answer !== null && answer !== []);
  });
}

export function getUserData() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_USER,
      payload: {
        loadingUserData: true,
      },
    });
    return axios
      .get(`${config.url}/api/user`, {
        headers: { authorization: localStorage.getItem('token') },
      })
      .then((response) => {
        const user = response?.data;
        if ('name' in user && 'answers' in user && 'email' in user && 'userTypeId' in user) {
          dispatch({
            type: ActionTypes.UPDATE_USER,
            payload: {
              name: response.data.name,
              answers: response.data.answers,
              email: response.data.email,
              userType: response.data.userTypeId,
              authenticated: true,
            },
          });
          if (Object.keys(response.data.answers).length !== 0 && isSurveyComplete(response.data.answers)) {
            dispatch({
              type: ActionTypes.COMPLETED_SURVEY,
            });
          } else {
            dispatch({ type: ActionTypes.REVISIT_SURVEY });
          }
        } else throw new Error('Error fetching user information');
      })
      .catch((error) => {
        console.log(error);
        localStorage.clear();
        dispatch({
          type: ActionTypes.DEAUTH_USER,
        });
        dispatch({
          type: ActionTypes.AUTH_ERROR,
        });
      })
      .finally(() => {
        dispatch({
          type: ActionTypes.UPDATE_USER,
          payload: {
            loadingUserData: false,
          },
        });
      });
  };
}

export function logOut() {
  localStorage.clear();
  return (dispatch) => {
    dispatch({ type: ActionTypes.DEAUTH_USER });
    dispatch({ type: ActionTypes.CLEAR_FEED });
    dispatch({ type: ActionTypes.CLEAR_SURVEY });
    dispatch({ type: ActionTypes.CLEAR_MATCHES });
    return Promise.resolve();
  };
}

export function goToProfile(history, email = null, backFunction = () => { }) {
  history.push({
    pathname: '/profile',
    backFunction,
  });
  return {
    type: ActionTypes.UPDATE_FEED,
    payload: { selectedEmail: email },
  };
}

export function getMatches() {
  return (dispatch) => {
    return axios
      .get(`${config.url}/api/matches`, {
        headers: { authorization: localStorage.getItem('token') },
      })
      .then((response) => {
        const matchData = response?.data;
        if ('matchesReciprocate' in matchData && 'matchesInitiateNoReciprocate' in matchData && 'numMatchesTargetNoReciprocate' in matchData) {
          dispatch({
            type: ActionTypes.UPDATE_MATCHES,
            payload: {
              usersRecip: response.data?.matchesReciprocate,
              usersNoRecip: response.data?.matchesInitiateNoReciprocate,
              requests: response.data?.numMatchesTargetNoReciprocate,
            },
          });
        } else throw new Error('Error getting matches');
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function postMatch(userTargetEmail) {
  return (dispatch) => {
    return axios
      .post(`${config.url}/api/match`, { userTargetEmail },
        {
          headers: { authorization: localStorage.getItem('token') },
        })
      .then((response) => {
        if (!response.data?.success) throw new Error('error sending match');
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: ActionTypes.UPDATE_USER,
          payload: { matchFailed: true },
        });
      });
  };
}

export function switchUserType(userType) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: ActionTypes.SWITCH_USER_TYPE,
        payload: { userType },
      });
      dispatch({ type: ActionTypes.CLEAR_FEED });
      dispatch({ type: ActionTypes.CLEAR_MATCHES });
      resolve();
    });
  };
}

export function getProfilePhoto(key, userEmail = null) {
  return (dispatch, getState) => {
    return axios.get(`${config.url}/api/profilephoto/${key}`, {
      headers: { authorization: localStorage.getItem('token') },
    })
      .then((response) => {
        if (response.data?.profilePhotoUrl) {
          if (userEmail) {
            dispatch({
              type: ActionTypes.UPDATE_FEED_PROFILE_PHOTO,
              payload: {
                url: response.data.profilePhotoUrl,
                email: userEmail,
              },
            });
          } else {
            dispatch({
              type: ActionTypes.UPDATE_PROFILE_PHOTO,
              payload: response.data.profilePhotoUrl,
            });
          }
        } else throw new Error('profile photo not found');
      })
      .catch((error) => {
        console.log(error);
        if (userEmail) {
          dispatch({
            type: ActionTypes.UPDATE_FEED_PROFILE_PHOTO,
            payload: {
              url: null,
              email: userEmail,
            },
          });
        } else {
          dispatch({
            type: ActionTypes.UPDATE_PROFILE_PHOTO,
            payload: null,
          });
        }
      });
  };
}
